import { Types } from "../actions/SparePartExcelActions";

const initialState = {
    excelList: [],
    uploadResponse: {},
};

export const SparePartExcelReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SPARE_PARTS_EXCEL_SET_EXCEL_LIST:
            return {
                ...state,
                excelList: action.payload || state.excelList,
            };
        case Types.SPARE_PARTS_SET_EXCEL_UPLOAD_FILE:
            return {
                ...state,
                uploadResponse: action.payload || state.uploadResponse,
            };
        default:
            return state;
    }
};
